import { useAppSelector } from "../../../../hooks/redux/redux";
import { Form } from "../../../../common/Form";
import { selectEditedTask, selectIsTasksSorting } from "../../tasksSlice";
import { useTranslation } from "react-i18next";
import { InputWrapper } from "../../../../common/InputWrapper";
import { MicrophoneIcon } from "../../../../common/icons";
import { InputButton } from "../../../../common/InputButton";
import { TaskFormButtons } from "./TaskFormButtons";
import { TaskInput } from "./TaskInput";
import { useTaskForm } from "../hooks/useTaskForm";

export const TaskForm = ({ taskForm }: { taskForm: ReturnType<typeof useTaskForm> }) => {
  const { t } = useTranslation("translation", { keyPrefix: "tasksPage" });
  const editedTask = useAppSelector(selectEditedTask);
  const isTasksSorting = useAppSelector(selectIsTasksSorting);
  const {
    inputValue,
    textAreaValue,
    formRef,
    inputRef,
    textAreaRef,
    handleChange,
    toggleSpeechRecognition,
    onSubmit,
    onCtrlEnter,
    handleCancel,
    speech,
  } = taskForm;

  return (
    <Form ref={formRef} onSubmit={onSubmit} $singleInput>
      <InputWrapper disabled={isTasksSorting}>
        <TaskInput
          inputValue={inputValue}
          textAreaValue={textAreaValue}
          name='taskName'
          edited={!!editedTask}
          inputRef={inputRef}
          textAreaRef={textAreaRef}
          onChange={handleChange}
          onKeyDown={onCtrlEnter}
          placeholder={t("form.inputPlaceholder")}
        />

        <InputButton
          type='button'
          aria-label='Toggle Speech Recognition'
          disabled={!speech.supportSpeech}
          onClick={toggleSpeechRecognition}
          $editedTask={!!editedTask}
        >
          <MicrophoneIcon $isActive={speech.isListening} />
        </InputButton>
      </InputWrapper>

      <TaskFormButtons
        edited={!!editedTask}
        disabled={speech.isActive || isTasksSorting}
        submitLabel={editedTask ? t("form.inputButton.saveChanges") : t("form.inputButton.addTask")}
        cancelLabel={t("form.inputButton.cancel")}
        onCancel={handleCancel}
      />
    </Form>
  );
};
